import { Grid } from "@material-ui/core";
import styled from "styled-components";
import { Flex } from "../../components/layout";
import { Widget } from "../../components/widget";

export const KycStatus = styled(Flex)`
  margin-left: 1em;
`;

export const FlexedGridItem = styled(Grid).attrs({
  item: true,
})<{ spaceBetween?: boolean }>`
  align-self: stretch;
  justify-content: center;
  align-items: center;
  display: flex;
  ${({ spaceBetween }) =>
    spaceBetween ? "justify-content: space-between;" : ""}
`;

export const StyledWidget = styled(Widget)`
  display: flex;
  flex-direction: column;
`;
